// extracted by mini-css-extract-plugin
export default {"container":"styles_container__Xd6ka","slide":"styles_slide__ROB81","slide-active":"styles_slide-active__H3PB9","slide-inactive":"styles_slide-inactive__6HuU2"};